<template>
  <div
    class="promotion-icon"
    :class="!disableDropdownItemClass ? 'dropdown-item' :  ''"
    :data-institution-promotion="dropdownId"
  >
    <a
      class="locator__place-promo-icon"
      v-if="promotion.logo && promotion.visible_on_places_list"
      @click="downloadPromotionAttachment(promotion, $event)"
      style="cursor: pointer"
      target="_blank"
      @mouseover="showPopup = true"
      @mouseleave="showPopup = false"
    >
      <img
        style="display: block;"
        width="76"
        height="61"
        v-bind:src="promotion.logo || ''"
        ref="image"
      />

      <div
        class="locator__place-promo-icon-description"
        v-if="showPopup && promotion.description_visibility"
        style="position: fixed"
        :style="{'top': `${popupTop}%`, 'left': `${popupLeft}%`}"
      >
        <h6 class="title">{{ promotionName }}</h6>
        <p class="text">{{ promotion.description }}</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "placePromotion",
  props: [
    "promotion",
    "institutionData",
    "dropdownId",
    "disableDropdownItemClass"
  ],
  data() {
    return {
      showPopup: false,
      popupTop: 0,
      popupLeft: 0
    };
  },
  computed: {
    promotionName() {
      return this.promotion.name.replace("<br>", " ");
    }
  },
  watch: {
    showPopup: {
      handler() {
        let pos = this.$refs.image.getBoundingClientRect();
        this.popupTop = (pos.y * 100) / window.innerHeight;
        this.popupLeft = (pos.width * 100) / window.innerWidth;
      }
    }
  },
  methods: {
    downloadPromotionAttachment(promotion, event) {
      if (!promotion.download_from_places_list) return;
      if (promotion.as_badge) return;
      event.preventDefault();
      event.stopPropagation();
      let url = this.getPromotionAttachmentUrl(promotion);
      window.open(url);
    },

    getPromotionAttachmentUrl(promotionData) {
      if (!promotionData.attachment_url) return "";
      let baseUrl = promotionData.attachment_url;
      baseUrl += "?institution=" + this.institutionData.institution.id;
      return baseUrl;
    }
  }
};
</script>

<style scoped>
.locator__place-promo-icons {
  margin-left: 30px;
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
